module.exports = __webpack_public_path__ + "images/柏纳s长图_03.jpg?v=86631f74";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_03.jpg
 ** module id = 158
 ** module chunks = 1 2
 **/